<template>
  <div
    id="users"
    class="row"
  >
    <div class="col-12">
      <vuetify-table
        :headers="headers"
        :api-u-r-l="apiURL"
        :readonly="true"
        title="Auditoria"
        :query-params="queryParams"
      >
        <template v-slot:filters>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="4">
              <v-menu
                v-model="form.dateMenu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="computedDateFormattedStart"
                    label="Fecha desde"
                    readonly
                    single-line
                    hide-details
                    v-on="on"
                  />
                </template>
                <v-col cols="12" style="padding: 0 !important;">
                  <v-date-picker
                    :color="themeColor"
                    :max="form.dateMax"
                    v-model="form.dateStart"
                    @input="form.dateMenu1 = false"
                  />
                </v-col>
                <v-col cols="12" sm="12" style="padding: 0 !important;">
                  <v-btn
                    block
                    :color="themeColor"
                    dark
                    @click="today('one')"
                  >
                    HOY
                  </v-btn>
                </v-col>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4">
              <v-menu
                v-model="form.dateMenu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="computedDateFormattedEnd"
                    label="Fecha hasta"
                    readonly
                    single-line
                    hide-details
                    v-on="on"
                  />
                </template>
                <v-col cols="12" style="padding: 0 !important;">
                  <v-date-picker
                    :color="themeColor"
                    v-model="form.dateEnd"
                    :max="form.dateMax"
                    @input="form.dateMenu2 = false"
                  />
                </v-col>
                <v-col cols="12" style="padding: 0 !important;">
                  <v-btn
                    block
                    :color="themeColor"
                    dark
                    @click="today('two')"
                  >
                    HOY
                  </v-btn>
                </v-col>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    :color="themeColor"
                    @click="downloadExcel"
                    v-on="on"
                    x-large
                  >
                    mdi-download
                  </v-icon>
                </template>
                <span>Descargar Excel</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </template>
      </vuetify-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from 'vform';
import moment from 'moment';
import { format, parseISO } from 'date-fns';
import VuetifyTable from '~/components/VuetifyTable';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('binnacle') };
  },
  components: {
    VuetifyTable,
  },
  data: () => ({
      headers: [{
          text: 'Usuario',
          value: 'name',
          align: 'left',
          sortable: true,
        }, {
          text: 'Rol',
          value: 'description',
          align: 'left',
          sortable: true,
        }, {
          text: 'Acción',
          value: 'accion',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Dirección IP',
          value: 'ip_address',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Fecha Creación',
          value: 'created_at',
          align: 'left',
          sortable: true,
        },
      ],
      items: [],
      totalItems: 0,
      apiURLBase: 'api/binnacle',
      form: new Form({
      dateStart: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateEnd: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateMax: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateMenu1: false,
      dateMenu2: false,
      binnacleE: '',
      rif: '',
      }),
  }),
  computed: {
    queryParams() {
      return `&dateStart=${this.form.dateStart}&dateEnd=${this.form.dateEnd}&binnacleEnterprise=${this.form.binnacleE}&rif=${this.form.rif}`;
    },
    apiURL() {
      return `${this.apiURLBase}`;
    },
    computedDateFormattedStart() {
        return this.form.dateStart ? moment(this.form.dateStart).format('DD-MM-YYYY') : '';
    },
    computedDateFormattedEnd() {
        return this.form.dateEnd ? format(parseISO(this.form.dateEnd), 'dd-MM-yyyy') : '';
    },
    ...mapGetters({
      themeColor: 'theme/themeColor',
    }),
},
  methods: {
    downloadExcel() {
          this.dowloading = true;
          const dateRange = moment(this.form.dateEnd).diff(this.form.dateStart, 'month', true);
            if (dateRange > 1) {
              this.$store.dispatch('notifications/show', {
                    message: 'El rango de consulta no debe ser mayor a un mes',
                    type: 'error',
                });
            } else {
                const url = '/api/download_excel_binnacle/export';
                window.axios({
                  method: 'post',
                  url,
                  responseType: 'arraybuffer',
                  data: this.form,
                }).then((response) => {
                    this.downloadFile(response, `Reporte de Auditoria  ${new Date().toISOString().slice(0, 10)}`);

                    setTimeout(() => { this.dowloading = false; }, 1000);
                })
                .catch(() => {
                });
            }
    },
    downloadFile(response, filename) {
      // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
      // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
      // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      const newBlob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename }.xlsx`;
      link.click();
      setTimeout(() => {
        // Para Firefox es necesario retrasar la revocación de ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    today(menu) {
      if (menu === 'one') {
        this.form.dateStart = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.form.dateMenu1 = false;
      } else {
        this.form.dateEnd = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.form.dateMenu2 = false;
      }
    },
  },
};
</script>
